module.exports = __webpack_public_path__ + "img/icon_evaluaciones.e642b23d.svg";